import { render } from "./DigitalText.vue?vue&type=template&id=59cc44c2&scoped=true"
import script from "./DigitalText.vue?vue&type=script&lang=js"
export * from "./DigitalText.vue?vue&type=script&lang=js"

import "./DigitalText.vue?vue&type=style&index=0&id=59cc44c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cc44c2"]])

export default __exports__